import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';

interface Props {
  icon: React.ReactElement;
  text: string;
  onClick?: () => void;
}
export const EmptyWidget: React.FC<Props> = ({ icon, text, onClick }) => {
  return (
    <StyledEmptyWidget data-testid="empty-widget" onClick={onClick}>
      {icon}
      {text}
    </StyledEmptyWidget>
  );
};
const StyledEmptyWidget = styled.div`
  width: 100%;
  border: 1px dashed ${token.gray200a};
  background-color: ${token.white};
  height: 120px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  display: flex;
  color: ${token.gray600a};
  :hover {
    color: ${token.gray800a};
    background-color: ${token.gray25};
    cursor: pointer;
    border-radius: ${token.radiusMedium};
  }
`;
